<div class="list-wrapper">
  <div *ngIf="group">
    <form-control-model [defaultHeight]="25" [columns]="columns" [group]="group" [model]="model"> </form-control-model>
  </div>
  <kgrid
    *ngIf="filterInfo && filterInfo.length > 0 && gridColumns && gridColumns.length > 0"
    [apiName]="apiName"
    [label]="label"
    [name]="apiName"
    [areaName]="areaName"
    pathPreFix="HRM"
    [isMulti]="false"
    [columns]="gridColumns"
    [SelectById]="'ElementId'"
    [isAdd]="false"
    [isDelete]="false"
    [defaultFilterKey]="filterInfo"
    [inputEditorform]="inputEditorform">
  </kgrid>
</div>
